/* Collection of helpers for dealing with Dates */
import moment from 'moment'

class DateHelpers {
  getDateString = (day) => {
    const year = day.getFullYear()
    const month = (1 + day.getMonth()).toString().padStart(2, '0')
    const dayStr = day.getDate().toString().padStart(2, '0')
    return `${month}/${dayStr}/${year}`
  }

  getDaysArray = (endDate) => {
    const start = new Date();
    start.setMonth(start.getMonth() - 1)
    const end = endDate ? new Date(endDate) : new Date()
    if (endDate) {
      end.setMonth(end.getMonth())
      end.setDate(end.getDate() + 1)
    } else {
      end.setMonth(end.getMonth() + 2)
    }
    for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
      const dateString = this.getDateString(dt)
      arr.push(`${dateString}`)
    }
    return arr
  }

  getDaysArrayForTrackers = (date) => {
    const start = new Date(date)
    start.setMonth(start.getMonth() - 1)
    const end = new Date(date)
    end.setMonth(end.getMonth() + 2)
    for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
      const dateString = this.getDateString(dt)
      arr.push(`${dateString}`)
    }
    return arr
  }

  getDateArry (startDate, endDate) {
    const sDate = new Date(startDate)
    const eDate = new Date(endDate)
    //To work in different timezone
    const start = new Date(sDate.getTime() + sDate.getTimezoneOffset() * 60000)
    const end = new Date(eDate.getTime() + eDate.getTimezoneOffset() * 60000)
    for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
      const dateString = this.getDateString(dt)
      arr.push(`${dateString}`)
    }
    return arr
}

  isYearEndDate = (date) => {
    if (date.month() === 11 && date.date() === 31) {
      // We show only the year for anything that is listed as coming out on 12/31/YYYY
      return true
    } else {
      return false
    }
  }

  getDateWithoutTime = (date) => {
    if (date) {
      return date.substring(0, date.indexOf('T'))
    }
    return date
  }

  isCurrentMonthPastOctober = () => {
    const currentDate = new Date()
    const october31 = new Date(currentDate.getFullYear(), 9, 31) //month 9 Ocotber
    if (currentDate > october31) {
      return true
    } else {
      return false
    }
  }

  formatMediaPlanningDate = (date) => {
    if (date) {
      const premiereDate = moment(this.getDateWithoutTime(date))
      const currentYear = new Date().getFullYear()
      const year = new Date(date).getFullYear()
      // DWA-3169 logic
      if ((year === currentYear && this.isYearEndDate(premiereDate) && !this.isCurrentMonthPastOctober()) || (year !== currentYear &&this.isYearEndDate(premiereDate))) {
        return premiereDate.format('YYYY')
      }
      return premiereDate.format('MM.DD.YYYY')
    }
    return date
  }

  formatDate = (date) => {
    if (date) {
      const premiereDate = moment(this.getDateWithoutTime(date))
      if (this.isYearEndDate(premiereDate)) {
        return premiereDate.format('YYYY')
      }
      return premiereDate.format('MMM DD, YYYY')
    }
    return date
  }

  getWeeksByDate = (startDate, endDate) => {
    const weeksByDate = []
    while (startDate <= endDate) {
      const firstDayOfWeek = new Date(startDate)
      const lastDayOfWeek = new Date(startDate)
      firstDayOfWeek.setDate(firstDayOfWeek.getDate() - firstDayOfWeek.getDay() + (firstDayOfWeek.getDay() === 0 ? -6 : 1))
      let endDate = new Date(firstDayOfWeek);
      lastDayOfWeek.setDate(endDate.getDate() +6)
      weeksByDate.push({
        startDateOfWeek: moment(new Date(firstDayOfWeek)).format('YYYY-MM-DD'),
        endDateOfWeek: moment(new Date(lastDayOfWeek)).format('YYYY-MM-DD'),
        displayDate: moment(new Date(firstDayOfWeek)).format('MMM DD') + ' - ' + moment(new Date(lastDayOfWeek)).format('MMM DD, YYYY'),
        startDateAndEndDate: moment(new Date(firstDayOfWeek)).format('YYYY-MM-DD') + '_' + moment(new Date(lastDayOfWeek)).format('YYYY-MM-DD')
      })
      startDate.setDate(startDate.getDate() + 7)
    }
    weeksByDate.sort((a, b) => {
        return moment(b.startDateOfWeek).toDate() - moment(a.startDateOfWeek).toDate();
    });
    return weeksByDate
  }
}

const instance = new DateHelpers()

export default instance
